import React, { useContext, useEffect, useState } from 'react';
import styled from "styled-components";
import { Cell } from './Cell';
import { Animated } from "react-animated-css";
import { AppContext } from '../../contexts/AppContext';
import moment from 'moment';
import {isOrderReady} from "../../helpers/OrderHelper";

const Wrapper = styled.div`
background-color: ${props => props.colorTheme.row.backgroundColor};
display:  flex;
flex-direction: row;
overflow-x: hidden;
overflow-y: hidden;
width: 100%;
margin: 5px;
margin-left: 0px;
border-radius: 4px;
height: 55px;
border-width: 1px !important;
border: solid;
border-color: ${props => props.colorTheme.row.borderColor};
`;

const deliveryStatusMap = {
    "ON_ROUTE": "On Route",
    "DRIVER_CHECKED_IN": "Checked In"
}


export function CardRow({ order }) {

    const [visible, setVisible] = useState(true);
    const [deliveryText, setDeliveryText] = useState('');
    const [deliveryImage, setDeliveryImage] = useState('');

    const { currentTheme, resources } = useContext(AppContext);

    useEffect(() => {
        console.log("order modified");
        setVisible(false);
        setTimeout(() => {
            setVisible(true);
        }, 500);
    }, [order]);

    useEffect(() => {
        setDeliveryImage(getDeliveryImage());
    }, [order, currentTheme]);

    const getOrderStatus = () => {
        return isOrderReady(order)? "Ready" : "In Progress";
    };

    const getDeliveryStatus = () => {
        const pickedUp = order.statusHistory.find((history) => {
            return history.status === "DRIVER_CHECKED_IN";
        });
        if (pickedUp) {
            return deliveryStatusMap["DRIVER_CHECKED_IN"];
        }
        return deliveryStatusMap["ON_ROUTE"];
    }

    const getDeliveryImage = () => {
        return getImage(order.sourceInfo ? order.sourceInfo.name : "")
    }

    const getImage = (name) => {
        if(resources[name]) {
            return resources[name].file[currentTheme.name];
        }

        setDeliveryText(order.sourceInfo ? order.sourceInfo.name : "");
        return null;
    }

    const getColor = (status) => {
        switch(status) {
            case 'In Progress': return currentTheme.dashboard.row.yellowText;
            case 'Ready': return currentTheme.dashboard.row.greenText;
            default: return "";
        }
    }

    const getOrderTime = () => {
        if (!order.orderTimestamp) {
            return '';
        }

        return new moment(Number(order.orderTimestamp)).format('HH:mm');
    }

    return (
        <Animated
            animationIn="flipInX"
            animationOut="flipOutX"
            isVisible={visible}
            animationInDuration={500}
            animationOutDuration={500}
        >

            <Wrapper colorTheme={currentTheme.dashboard}>
                <Cell text={getOrderTime()} dynamicText={true}/>
                <Cell text={order.externalId} dynamicText={true}/>
                <Cell image={deliveryImage} backupText={order.sourceInfo ? order.sourceInfo.name : ''} text={deliveryText} />
                <Cell text={order.brandInfo ? order.brandInfo.name : ""} />
                <Cell text={getOrderStatus()} color={getColor(getOrderStatus())} />
                <Cell text={getDeliveryStatus()} />

            </Wrapper>
        </Animated>

    );
}